// import React,{useEffect} from 'react'
// import { Link } from 'react-router-dom';
// import { IoIosArrowForward } from "react-icons/io";
// import './Gallery.css'
// const Testimonial = () => {

//   useEffect(() => {
//     const gallery = document.querySelector('.gallery');
//     const track = document.querySelector('.gallery-track');
//     const cards = document.querySelectorAll('.card_gallery');
//     const easing = 0.05;
//     let startY = 0;
//     let endY = 0;
//     let raf;

//     const lerp = (start, end, t) => start * (1 - t) + end * t;

//     function updateScroll() {
//       startY = lerp(startY, endY, easing);
//       gallery.style.height = `${track.clientHeight}px`;
//       track.style.transform = `translateY(-${startY}px)`;
//       activateParallax();
//       raf = requestAnimationFrame(updateScroll);
//       if (startY.toFixed(1) === window.scrollY.toFixed(1)) cancelAnimationFrame(raf);
//     }

//     function startScroll() {
//       endY = window.scrollY;
//       cancelAnimationFrame(raf);
//       raf = requestAnimationFrame(updateScroll);
//     }

//     function parallax(card) {
//       const wrapper = card.querySelector('.card-image-wrapper');
//       const diff = card.offsetHeight - wrapper.offsetHeight;
//       const { top } = card.getBoundingClientRect();
//       const progress = top / window.innerHeight;
//       const yPos = diff * progress;
//       wrapper.style.transform = `translateY(${yPos}px)`;
//     }

//     const activateParallax = () => cards.forEach(parallax);

//     function init() {
//       activateParallax();
//       startScroll();
//     }

//     window.addEventListener('load', updateScroll, false);
//     window.addEventListener('scroll', init, false);
//     window.addEventListener('resize', updateScroll, false);
//   }, []);

//   return (
//   <div>
//      <div className='bg_banner_gallery'>
//          <h1>Gallery</h1>
//          <div className='bread_craum'>
//             <Link to="/" style={{textDecoration:"auto",fontFamily:"Nunito",color:"#0F172B"}}>Home</Link>
//              <IoIosArrowForward style={{color:"#0F172B",marginTop:"4px"}}/>
//             <Link to="" style={{textDecoration:"auto",fontFamily:"Nunito",color:"#0F172B"}}>Gallery</Link>
//          </div>
//     </div>

//     <div className="gallery-container">
//         <main className='gallery'>
//           <div className='gallery-track'>
//             <div className='card_gallery'>
//               <div className='card-image-wrapper'>
//                 <img src='/images/bg1.jpg' />
//               </div>
//             </div>

//           <div className='card_gallery'>
//             <div className='card-image-wrapper'>
//               <img src='/images/DeWatermark.ai_1714025244832.png'/>
//           </div>
//             </div>
//             <div className='card_gallery'>
//       <div className='card-image-wrapper'>
//         <img src='/images/gallery5.png'/>
//       </div>
//     </div>
//     <div className='card_gallery'>
//       <div className='card-image-wrapper'>
//         <img src='/images/gallery1.jpeg'/>
//       </div>
//     </div>
//     <div className='card_gallery'>
//       <div className='card-image-wrapper'>
//         <img src='/images/gallery2.jpeg'/>
//       </div>
//     </div>
//     <div className='card_gallery'>
//       <div className='card-image-wrapper'>
//         <img src='/images/gallery11.jpeg'/>
//       </div>
//     </div>
//     <div className='card_gallery'>
//       <div className='card-image-wrapper'>
//         <img src='/images/gallery18.png'/>
//       </div>
//     </div>
//     <div className='card_gallery'>
//       <div className='card-image-wrapper'>
//         <img src='/images/gallery16.png'/>
//       </div>
//     </div>
//     <div className='card_gallery'>
//       <div className='card-image-wrapper'>
//         <img src='/images/gallery17.png'/>
//       </div>
//     </div>
//     <div className='card_gallery'>
//       <div className='card-image-wrapper'>
//         <img src='/images/DeWatermark.ai_1714025203134.png'/>
//       </div>
//     </div>
//     <div className='card_gallery'>
//       <div className='card-image-wrapper'>
//         <img src='/images/DeWatermark.ai_1714025214996.png'/>
//       </div>
//     </div>
//     <div className='card_gallery'>
//       <div className='card-image-wrapper'>
//         <img src='/images/gallery15.png'/>
//       </div>
//     </div>
//     <div className='card_gallery'>
//       <div className='card-image-wrapper'>
//         <img src='/images/gallery14.png'/>
//       </div>
//     </div>
//     <div className='/images/gallery10.png'>
//       <div className='card-image-wrapper'>
//         <img src='https://source.unsplash.com/bOvvgayPCyI'/>
//       </div>
//     </div>
//     <div className='card_gallery'>
//       <div className='card-image-wrapper'>
//         <img src='/images/card4.png'/>
//       </div>
//     </div>
//     </div>

//         </main>
//       </div>

//   </div>
//   )
// }
// export default Testimonial;

import React from "react";
import { Link } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";
import './Gallery.css'
const Testimonial = () => {
  return (
    <div>
      <div className='bg_banner_gallery'>
          <h1>Gallery</h1>
         <div className='bread_craum'>
             <Link to="/" style={{textDecoration:"auto",fontFamily:"Nunito",color:"#0F172B"}}>Home</Link>
              <IoIosArrowForward style={{color:"#0F172B",marginTop:"4px"}}/>
             <Link to="" style={{textDecoration:"auto",fontFamily:"Nunito",color:"#0F172B"}}>Gallery</Link>
          </div>
     </div>
      <div class="container_dd">
        <h1 class="heading_dd">
         
        </h1>

        <div class="gallery">
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="/images/bg1.jpg"
              alt="person writing in a notebook beside by an iPad, laptop, printed photos, spectacles, and a cup of coffee on a saucer"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="/images/DeWatermark.ai_1714025244832.png"
              alt="sunset behind San Francisco city skyline"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="/images/gallery5.png"
              alt="people holding umbrellas on a busy street at night lit by street lights and illuminated signs in Tokyo, Japan"
            />
          </div>

          {/* <div class="gallery-item">
            <img
              class="gallery-image"
              src="/images/gallery1.jpeg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div> */}

         
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="/images/gallery16.png"
              alt="man wearing a black jacket, white shirt, blue jeans, and brown boots, playing a white electric guitar while sitting on an amp"
            />
          </div>
          <div class="gallery-item">
            <img
              class="gallery-image"
              src="/images/gallery18.png"
              alt="man wearing a black jacket, white shirt, blue jeans, and brown boots, playing a white electric guitar while sitting on an amp"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="/images/gallery17.png"
              alt="man wearing a black jacket, white shirt, blue jeans, and brown boots, playing a white electric guitar while sitting on an amp"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="/images/gallery2.jpg"
              alt="back view of woman wearing a backpack and beanie waiting to cross the road on a busy street at night in New York City, USA"
            />
          </div>

          <div class="gallery-item">
            <img
              class="gallery-image"
              src="/images/gallery11.jpg"
              alt="man wearing a black jacket, white shirt, blue jeans, and brown boots, playing a white electric guitar while sitting on an amp"
            />
          </div>

           <div class="gallery-item">
            <img
              class="gallery-image"
              src="/images/gallery1.jpeg"
              alt="car interior from central back seat position showing driver and blurred view through windscreen of a busy road at night"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
